module.exports = function negotiateName(event, comparedEvent) {
    if(event.location && event.location.street) {
        comparedEvent.place = event.place;
    }
}
